<template>
  <div class="sip_btn_up_down">
    <div class="sip_btn_up" @click="onUp" v-html="btnUp" />
    <div class="sip_btn_down" @click="onDown" v-html="btnDown" />
  </div>
</template>
<script>
const btnUp = `
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path class="fill" d="M19.9738 21.9462C21.1632 22.3384 22.2041 22.7304 22.9547 23.0275L12 1.11803L1.04526 23.0275C1.79593 22.7304 2.83678 22.3384 4.02623 21.9462C6.42862 21.1541 9.49255 20.3421 12 20.3421C14.5074 20.3421 17.5714 21.1541 19.9738 21.9462Z" fill="#599EC4" stroke="white" stroke-linejoin="round"/>
    <path d="M12.0005 19.9593C8.08648 19.9694 3.74322 21.547 2.05762 22.1128L4.864 19.5742C5.91343 19.1765 8.74463 18.4661 12.0005 18.4968C15.2564 18.5276 18.1947 19.2794 19.2569 19.6515L21.9483 22.1072C20.5283 21.6365 15.7373 19.9497 12.0005 19.9593Z" fill="#2A7288"/>
    <path d="M2.05176 22.1073L12.0002 2.25549L21.9312 22.0961L19.2478 19.6528L12.0002 5.10351L4.85889 19.5747L2.05176 22.1073Z" fill="#8BCAED"/>
</svg> `
const btnDown = `
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="fill" d="M19.9738 2.0538C21.1632 1.6616 22.2041 1.26958 22.9547 0.97248L12 22.882L1.04526 0.97248C1.79593 1.26958 2.83678 1.6616 4.02623 2.0538C6.42862 2.84595 9.49255 3.65789 12 3.65789C14.5074 3.65789 17.5714 2.84595 19.9738 2.0538Z" fill="#599EC4" stroke="white" stroke-linejoin="round"/>
  <path d="M12.0005 4.0696C8.08648 4.0595 3.74322 2.48197 2.05762 1.91612L4.864 4.45472C5.91343 4.85242 8.74463 5.56287 12.0005 5.53208C15.2564 5.50129 18.1947 4.74951 19.2569 4.37746L21.9483 1.92172C20.5283 2.39246 15.7373 4.07925 12.0005 4.0696Z" fill="#8BCAED"/>
  <path d="M2.05176 1.92162L12.0002 21.7734L21.9312 1.93283L19.2478 4.37616L12.0002 18.9254L4.85889 4.45428L2.05176 1.92162Z" fill="#2A7288"/>
</svg> `

export default {
  name: 'ControlsUpDown',
  data() {
    return {
      btnUp,
      btnDown,
    }
  },
  props: ['speed'],
  methods: {
    onUp() {
      this.$emit('clicked', true)
    },
    onDown() {
      this.$emit('clicked', false)
    },
  },
}
</script>

<style lang="stylus">
.sip_btn_up_down
  @media screen and (max-width: 900px)
    align-self center
  .sip_btn_up
    margin-bottom 5px
  .sip_btn_up,
  .sip_btn_down
    width 40px
    height 40px
    background #2F7F98
    border 1px solid #FFFFFF
    box-sizing border-box
    border-radius 6px
    padding 10px
    cursor pointer
    @media screen and (max-width: 900px)
      width 50px
      height 50px
      padding 9px
      svg
        width 30px
        height 30px
</style>